import { render, staticRenderFns } from "./TypeTwoGraph.vue?vue&type=template&id=0bdf11d6&scoped=true&"
import script from "./TypeTwoGraph.vue?vue&type=script&lang=js&"
export * from "./TypeTwoGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf11d6",
  null
  
)

export default component.exports